import { Component, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'mwo-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  @Input() title: string;

  @Input() click: any;

  constructor() { }

  ngOnInit() {
  }

}
